// vistas/Compromiso/DetalleCompromisoPublico.js
import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import {
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
  Snackbar,
  Alert,
  Grid,
  Paper,
  Box,
  Container,
  Toolbar, // Agregar este import
} from '@mui/material';
import { getCompromisoPorNormativa } from '../../componentes/http/actions/CompromisoAction';
import AppBarPublico from '../../componentes/navegacion/AppBarPublico';

const DetalleCompromisoPublico = () => {
  const { idNormativa } = useParams();
  const [compromisos, setCompromisos] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const fetchCompromisos = useCallback(() => {
    setIsLoading(true);
    
    // Para usuarios públicos, no pasar token (será null)
    getCompromisoPorNormativa(null, idNormativa)
      .then((response) => {
        setCompromisos(response);
      })
      .catch((error) => {
        console.error("Error fetching compromisos:", error);
        setSnackbar({
          open: true,
          message: "Error al cargar los compromisos",
          severity: "error",
        });
      })
      .finally(() => {
        setIsLoading(false);
        setInitialDataLoaded(true);
      });
  }, [idNormativa]);

  useEffect(() => {
    if (idNormativa) {
      fetchCompromisos();
    }
  }, [fetchCompromisos, idNormativa]);

  const nombreNormativa = compromisos.length > 0 ? compromisos[0].nombreNormativa : null;

  return (
    <>
      {/* AppBar público */}
      <AppBarPublico />
      
      {/* Espaciado para compensar el AppBar fijo */}
      <Toolbar />
      
      <Container maxWidth="lg">
        <Box sx={{ mt: 4, mb: 4 }}>
          <Grid container direction="column" spacing={2}>
            <Paper sx={{ p: 3, mb: 3 }}>
              <Grid item>
                <Typography variant="h4">
                  Compromisos
                </Typography>
                {nombreNormativa && (
                <Typography variant="h6" sx={{ mt: 1 }}>
                  Normativa: {nombreNormativa}
                </Typography>
                )}
              </Grid>

              {isLoading && !initialDataLoaded ? (
                <Box display="flex" justifyContent="center" p={3}>
                  <CircularProgress />
                </Box>
              ) : compromisos.length > 0 ? (
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Descripción</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {compromisos.map((compromiso) => (
                      <TableRow key={compromiso.id}>
                        <TableCell>{compromiso.descripcion}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              ) : (
                <Typography>No hay compromisos para esta normativa.</Typography>
              )}

              <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
              >
                <Alert
                  onClose={() => setSnackbar({ ...snackbar, open: false })}
                  severity={snackbar.severity}
                  sx={{ width: "100%" }}
                >
                  {snackbar.message}
                </Alert>
              </Snackbar>
            </Paper>
          </Grid>
        </Box>
      </Container>
    </>
  );
};

export default DetalleCompromisoPublico;